<div [ngClass]="cssClasses()">
  <div #scroller class="scrollable__scroll" (scroll)="onScroll()">
    <div #content class="scrollable__content">
      <ng-content></ng-content>
    </div>
  </div>
  <div class="scrollable__shadow scrollable__shadow--left"></div>
  <div class="scrollable__shadow scrollable__shadow--right"></div>
</div>
